import styled from "styled-components";

export const MobileTournamentMoreWrapper = styled.div`
  width: 100%;
  height: 100dvh;
  box-sizing: border-box;
  padding: 68px 0 100px;
  overflow-y: auto;
  font-family: Pretendard;
`;
